const FA = "۰۱۲۳۴۵۶۷۸۹";

export const fa = (n: number | string) => String(n).replace(/\d/g, (d) => FA[Number(d)]);

export const faPrice = (n: number) => new Intl.NumberFormat("fa-IR").format(n);

export function timeAgo(iso?: string | null): string {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    const diff = Math.max(0, Date.now() - d.getTime());
    const min = Math.floor(diff / 60000);
    if (min < 1) return "همین حالا";
    if (min < 60) return `${fa(min)} دقیقه پیش`;
    const h = Math.floor(min / 60);
    if (h < 24) return `${fa(h)} ساعت پیش`;
    const days = Math.floor(h / 24);
    if (days === 1) return "دیروز";
    if (days < 7) return `${fa(days)} روز پیش`;
    return d.toLocaleDateString("fa-IR");
}

export const CONDITION_LABEL: Record<string, string> = {
    new: "نو",
    like_new: "در حد نو",
    used: "دست‌دوم",
};



/** متن قدیمی انجمن ممکن است HTML باشد (فقط محتوای قدیمیِ مدیر)؛ محتوای جدید همیشه متن ساده است */
export const looksLikeHtml = (s: string) => /<[a-z][\s\S]*>/i.test(s || "");

export const FORUM_BASE = "/forum";
export const topicPath = (id: number) => `${FORUM_BASE}/topic-${id}`;
export const tagPath = (slug: string) => `${FORUM_BASE}/tag/${encodeURIComponent(slug)}`;
export const adPath = (slug: string) => `${FORUM_BASE}/v/${encodeURIComponent(slug)}`;

/** مسیر دسته‌بندی؛ پیش‌فرض forum/cat (از NEXT_PUBLIC_FORUM_CATEGORY). نام پوشه‌ی route باید با همین مقدار یکی باشد. */
export const CAT_BASE = `/${(process.env.NEXT_PUBLIC_FORUM_CATEGORY || "forum/cat").replace(/^\/+|\/+$/g, "")}`;
export const catPath = (slug: string, tab?: "q" | "ads") =>
    `${CAT_BASE}/${encodeURIComponent(slug)}${tab === "ads" ? "?tab=ads" : ""}`;

export const absUrl = (path: string) => `${process.env.NEXT_PUBLIC_URL ?? ""}${path}`;
